<template>
    <i class="scratch-icon icon-copper">c</i>
</template>

<script>
    export default {
        name: 'IconCopper'
    }
</script>

<style scoped>
@import "../assets/scratch.css";
.icon-copper {
    background: url("../assets/icons/copper.png") no-repeat;
}
</style>